(<template>
  <div>
    <el-upload name="image"
               :with-credentials="true"
               :file-list="uploadedImages"
               :action="uploadUrl"
               multiple
               list-type="picture-card"
               :on-preview="preview"
               :on-remove="remove"
               :on-success="add"
               accept="image/*">
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="isDialogVisible" :append-to-body="true">
      <img width="100%" :src="dialogImageUrl" alt>
    </el-dialog>
  </div>
</template>)

(<script>
export default {
  name: 'image-uploader',
  props: ['images'],
  data () {
    var uploadedImages = []
    if (this.images && this.images.length > 0) {
      this.images.map((tmpImage, index, arr) => {
        uploadedImages.push({
          response: tmpImage.split('/').pop(),
          url: tmpImage
        })
        arr.splice(index, 1, tmpImage.split('/').pop())
      })
    }
    return {
      uploadUrl: `${process.env.SERVER_URL}/images`,
      dialogImageUrl: '',
      isDialogVisible: false,
      uploadedImages
    }
  },
  methods: {
    remove (file) {
      this.$emit('image-removed', file.response)
    },
    preview (file) {
      this.dialogImageUrl = file.url
      this.isDialogVisible = true
    },
    add (response) {
      this.$emit('image-added', response)
    }
  }
}
</script>)



// WEBPACK FOOTER //
// src/components/Image-Uploader.vue